module.exports = __webpack_public_path__ + "img/firSub2.71e1e3a6.png";